export const LOAD_ANNOTATIONS = "epadjs/annotationList/LOAD_ANNOTATIONS";
export const LOAD_ANNOTATIONS_SUCCESS =
  "epadjs/annotationList/LOAD_ANNOTATIONS_SUCCESS";
export const LOAD_ANNOTATIONS_ERROR =
  "epadjs/annotationList/LOAD_ANNOTATIONS_ERROR";
// -----> Delete after v1.0 <-----
// export const LOAD_PATIENT = 'epadjs/annotationList/LOAD_PATIENT';
// export const LOAD_PATIENT_ERROR = 'epadjs/annotationList/LOAD_PATIENT_ERROR';
// export const LOAD_PATIENT_SUCCESS =
//   'epadjs/annotationList/LOAD_PATIENT_SUCCESS';
export const VIEWPORT_FULL = "epadjs/annotationList/VIEWPORT_FULL";
export const UPDATE_ANNOTATION_DISPLAY =
  "epadjs/annotationList/UPDATE_ANNOTATION_DISPLAY";
export const TOGGLE_ALL_ANNOTATIONS =
  "epadjs/annotationList/TOGGLE_ALL_ANNOTATIONS";
export const TOGGLE_ALL_LABELS = "epadjs/annotationList/TOGGLE_ALL_LABELS";
export const TOGGLE_LABEL = "epadjs/annotationList/TOGGLE_LABEL";
export const CHANGE_ACTIVE_PORT = "epadjs/annotationList/CHANGE_ACTIVE_PORT";
export const LOAD_SERIE_SUCCESS = "epadjs/annotationList/LOAD_SERIE_SUCCESS";
export const SHOW_ANNOTATION_WINDOW =
  "epadjs/annotationList/SHOW_ANNOTATION_WINDOW";
export const SELECT_PROJECT = "epadjs/annotationList/SELECT_PROJECT";
export const SELECT_PATIENT = "epadjs/annotationList/SELECT_PATIENT";
export const SELECT_SERIE = "epadjs/annotationList/SELECT_SERIE";
export const SELECT_STUDY = "epadjs/annotationList/SELECT_STUDY";
export const SELECT_ANNOTATION = "epadjs/annotationList/SELECT_ANNOTATION";
export const CLEAR_GRID = "epadjs/annotationList/CLEAR_GRID ";
export const CLEAR_SELECTION = "epadjs/annotationList/CLEAR_SELECTION ";
// -----> Delete after v1.0 <-----
// export const DISPLAY_SINGLE_AIM = 'epadjs/annotationList/DISPLAY_SINGLE_AIM';
export const JUMP_TO_AIM = "epadjs/annotationList/JUMP_TO_AIM";
export const ADD_TO_GRID = "epadjs/annotationList/ADD_TO_GRID";
export const LOAD_COMPLETED = "epadjs/annotationList/LOAD_COMPLETED";
export const START_LOADING = "epadjs/annotationList/START_LOADING";
// -----> Delete after v1.0 <-----
// export const UPDATE_PATIENT = 'epadjs/annotationList/UPDATE_PATIENT';
export const CLOSE_SERIE = "epadjs/annotationList/CLOSE_SERIE";
export const UPDATE_IMAGEID = "epadjs/annotationList/UPDATE_IMAGEID";
export const CLEAR_AIMID = "epadjs/annotationList/CLEAR_AIMID";
// -----> Delete after v1.0 <-----
// export const UPDATE_PATIENT_AIM_SAVE =
//   'epadjs/annotationList/UPDATE_PATIENT_AIM_SAVE';
// export const UPDATE_PATIENT_AIM_DELETE =
//   'epadjs/annotationList/UPDATE_PATIENT_AIM_DELETE';
export const GET_NOTIFICATIONS = "epadjs/annotationList/GET_NOTIFICATIONS";
// -----> Delete after v1.0 <-----
// export const UPDATE_IMAGE_INDEX = 'epadjs/annotationList/UPDATE_IMAGE_INDEX ';
export const GET_PROJECT_MAP = "epadjs/annotationList/GET_PROJECT_MAP";
export const SET_SEG_LABEL_MAP_INDEX =
  "epadjs/annotationList/SET_SEG_LABEL_MAP_INDEX";
export const GET_TEMPLATES = "epadjs/annotationList/GET_TEMPLATES";
export const SEG_UPLOAD_STARTED = "epadjs/annotationList/SEG_UPLOAD_STARTED";
export const SEG_UPLOAD_COMPLETED =
  "epadjs/annotationList/SEG_UPLOAD_COMPLETED";
export const SEG_UPLOAD_REMOVE = "epadjs/annotationList/SEG_UPLOAD_REMOVE";
export const AIM_DELETE = "epadjs/annotationList/AIM_DELETE";
export const SAVE_PATIENT_FILTER = "epadjs/annotationList/SAVE_PATIENT_FILTER";
export const REPLACE_IN_GRID = "epadjs/annotationList/REPLACE_IN_GRID";
export const UPDATE_SEARCH_TABLE_INDEX = "epadjs/annotationList/UPDATE_SEARCH_TABLE_INDEX ";
export const REFRESH_MAP = "epadjs/annotationList/REFRESH_MAP";
export const AIM_SAVE = "epadjs/annotationList/AIM_SAVE";
export const SUBPATH = "epadjs/annotationList/SUBPATH";
export const CHECK_MULTIFRAME = 'epadjs/annotationList/CHECK_MULTIFRAME';
export const CLEAR_MULTIFRAME_AIM_JUMP = 'epadjs/annotationList/CLEAR_MULTIFRAME_AIM_JUMP';
export const SET_SERIES_DATA = 'epadjs/annotationList/SET_SERIES_DATA';
export const FILL_DESC = 'epadjs/annotationList/FILL_DESC';
export const STORE_AIM_SELECTION = 'epadjs/annotationList/STORE_AIM_SELECTION';
export const STORE_AIM_SELECTION_ALL = 'epadjs/annotationList/STORE_AIM_SELECTION_ALL';
export const TOGGLE_ALL_CALCULATIONS = 'epadjs/annotationList/TOGGLE_ALL_CALCULATIONS';
export const SET_LAST_LOCATION = 'epadjs/annotationList/SET_LAST_LOCATION';
export const SHOW_PHI = 'epadjs/annotationList/SHOW_PHI';

export const commonLabels = {
  button: { background: "#6c757d", color: "#ECECEC", border: "#acacac solid 1px" },
  label: { background: "#616970", color: "white" },
};

export const colors = [
  {
    button: { background: "#e450a8" },
    label: { background: "#773350" },
  },
  {
    button: { background: "#f9a45a" },
    label: { background: "#7d522e" },
    // label: { background: "#7d522d" },
  },
  // {
  // button: { background: "#02c7b0" },
  // label: { background: "#0f7569" },
  // },
  {
    button: { background: "#72ba6f" },
    label: { background: "#395e38" },
  },
  {
    button: { background: "#b03544" },
    label: { background: "#750f29" },
  },
  {
    button: { background: "#00b7ed" },
    label: { background: "#005b76" },
  },
  {
    button: { background: "#00994b" },
    label: { background: "#004d26" },
  },
  {
    button: { background: "#066ffa" },
    label: { background: "#03387d" },
  },
  {
    button: { background: "#ff6d00" },
    label: { background: "#783126" },
  },
  {
    button: { background: "#9e5c9c" },
    label: { background: "#4f2e4e" },
  },
  {
    button: { background: "#17534b" },
    label: { background: "#083a38" },
  },
  {
    button: { background: "#872981" },
    label: { background: "#431541" },
  },
  {
    button: { background: "#008484" },
    label: { background: "#004242" },
  },
]

// export const colors = [
//   {
//     button: { background: "#e6194B", color: "black" },
//     label: { background: "#8a0d2a", color: "white" },
//   },
//   // { button: { background: "#ffe119", color: "black" },
//   //   label: { background: "#786d22", color: "white" }
//   // },
//   {
//     button: { background: "#3cb44b", color: "black" },
//     label: { background: "#3d7540", color: "white" },
//   },
//   {
//     button: { background: "#42d4f4", color: "black" },
//     label: { background: "#4a8c99", color: "white" },
//   },
//   {
//     button: { background: "#ff9000", color: "black" },
//     label: { background: "#915d38", color: "white" },
//   },
//   {
//     button: { background: "#4363d8", color: "white" },
//     label: { background: "#49598f", color: "white" },
//   },
//   {
//     button: { background: "#911eb4", color: "white" },
//     label: { background: "#632a73", color: "white" },
//   },
//   {
//     button: { background: "#7ebfb1", color: "black" },
//     label: { background: "#397d74", color: "white" },
//   },
//   {
//     button: { background: "#ffc0cb", color: "black" },
//     label: { background: "#9e5857", color: "white" },
//   },
//   {
//     button: { background: "#fffac8", color: "black" },
//     label: { background: "#9e9859", color: "white" },
//   },
//   {
//     button: { background: "#aaffc3", color: "black" },
//     label: { background: "#489c5f", color: "white" },
//   },
//   {
//     button: { background: "#e6beff", color: "black" },
//     label: { background: "#7e5296", color: "white" },
//   },
// ];
